/**
 * Created by Alex Aguilar on 8/8/2016.
 */
(function(){
    'use strict';

    var scrollContent = {
        transclude: true,
        templateUrl: 'app/components/scroll/scroll.html',
        controller: scrollContentController,
        controllerAs: 'vm',
        bindings:{
            scroll: '@',
            size: '@',
            percentage: '='
        }
    };

    function scrollContentController(){
        var vm = this;
        vm.style = "";

        if(vm.scroll == "horizontal"){
            vm.style = (vm.percentage && vm.percentage != undefined) ? "width: 100%" : "width:" + vm.size + "px";
        }else if(vm.scroll == "vertical"){
            vm.style = (vm.percentage && vm.percentage != undefined) ? "height: 100%" : "height:" + vm.size + "px";
        }
    }

    angular
        .module('completeAir')
        .component('scrollContent', scrollContent);
})();
